module.exports = __webpack_public_path__ + "static/media/feature_3.31b9382a.jpg";